import SimpleCalendar from 'simple-calendar-js';
import 'simple-calendar-js/dist/simple-calendar-js.min.css';

const initCalendar = () => {
    const calendarElement = document.querySelector('.calendar');

    if (!calendarElement) {
        return;
    }

    new SimpleCalendar(calendarElement, {
        defaultView: 'month',
        mode: 'calendar',
        locale: 'en-GB',
        weekStartsOn: 1,
        darkMode: 'auto',
        allowHtmlInEvents: true,
        timezone: 'local',
        monthTimedEventStyle: 'list',
        onDateSelect: (date) => {
            console.log('Selected date:', date);
        },
    });
};

// initCalendar();

export default initCalendar;